import { LockOutlined } from '@ant-design/icons';

export const LockIcon = ({ fill = '#FFE082', className }) => {
  return <LockOutlined style={{ cursor: 'pointer' }} />;
};
